import { AbortControllerManager } from '../abortControllerManager';
import { authClient } from '../client';
import {
  ICalendarAvailabilityRequest,
  TCalendarAvailabilityResponse,
} from '@/types/calendar';

class CalendarApi extends AbortControllerManager {
  private readonly CALENDAR_URL = '/v2/calendar';

  constructor() {
    super();
  }

  getCalendarAvailability(
    body: ICalendarAvailabilityRequest,
  ): Promise<TCalendarAvailabilityResponse> {
    const signal = this.createAbortController('getCalendarAvailability');
    return authClient.post(`${this.CALENDAR_URL}/availability`, body, {
      signal,
    });
  }
}

export const calendarApi = new CalendarApi();
